/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { AppAlert, AppLogo, LaddaButton } from "@advapacs/common";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IRootState } from "../../config/reducers";
import { useAppDispatch } from "../../config/store";
import { resendEmail } from "./ducks/operations";
import { AuthenticationLayout } from "@src/components/AuthenticationLayout";

interface ISuccessRegister {
  email: string;
}

export const SuccessRegister: FC<ISuccessRegister> = ({ email }) => {
  const dispatch = useAppDispatch();
  const { individualResponse, organisationResponse, errorMessage, loading } =
    useSelector((state: IRootState) => state.signUpSlice);
  const { t } = useTranslation("login");

  return (
    <>
      <AuthenticationLayout>
        <>
          {errorMessage && <AppAlert.ErrorAlert error={errorMessage} />}
          <div className="mb-0">
            <div className="logo flex-center">
              <AppLogo.CPLogoMain noMargin width={220} height={70} />
            </div>
            <div className="mt-3">
              <div className="form-group text-center">
                <h5>{t("your_sign_up_was_successful")}</h5>
              </div>
              <div className="form-group text-center">
                <p className="m-b-none">
                  {t("we_have_sent_activation_email_instructions_to")}
                </p>
                <a href={`mailto:${email}`}>{email}</a>
                <p className="m-b-none">
                  {t(
                    "if_you_do_not_receive_the_email_please_check_your_spam_or_junk_email_folder"
                  )}
                </p>
                <p className="m-b-none">
                  {t(
                    "you_can_also_click_resend_button_below_to_have_another_email_sent"
                  )}
                </p>
              </div>
              <div className="form-group text-center">
                <LaddaButton
                  type="button"
                  className="btn btn-primary"
                  btnName={t("resend_verification_email")}
                  loading={loading}
                  onClickHandler={(e) => {
                    e.preventDefault();
                    dispatch(
                      resendEmail(
                        individualResponse?.id || organisationResponse?.id
                      )
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </>
      </AuthenticationLayout>
    </>
  );
};
